export const formatNotificationsCount = (value: number): string =>
  value > 99 ? "99+" : String(value);
